import { ProductID } from '@kamernet/core/ApiClient/Kamernet';
import {
  parseRouteParamToEnum,
  parseRouteParamToInt,
  parseRouteParamToObject,
} from '@kamernet/utilities/URL';

import { defineRoute } from '../defineRoute';

import { PaymentStatusMessage } from './PaymentStatus';

export const DEFAULT_PAYMENT_STATUS_SUCCESS_MESSAGE =
  {} as PaymentStatusMessage;

export const DEFAULT_SELECT_PRODUCT = ProductID.PremiumOneMonthTenant;
export const DEFAULT_SELECT_PRODUCT_RATE_PLAN = 0;

export type MakePaymentRouteParams = {
  paymentStatusSuccessMessage?: PaymentStatusMessage | null;
  selectedProduct?: ProductID | null;
  selectedProductRatePlan?: number | null;
};

export type MakePaymentRouteParamsString = {
  paymentStatusSuccessMessage?: string;
  selectedProduct?: string;
  selectedProductRatePlan?: string;
};

export const MakePayment = defineRoute<
  MakePaymentRouteParams,
  MakePaymentRouteParamsString
>({
  pathname: '/premium-account-payment/make-payment',
  nlPathname: '/premium-account-betaling/betaal',
  routeParamsStringifier: routeParams => {
    return {
      selectedProduct: routeParams.selectedProduct?.toString(),
      selectedProductRatePlan: routeParams.selectedProductRatePlan?.toString(),
      paymentStatusSuccessMessage: routeParams.paymentStatusSuccessMessage
        ? JSON.stringify(routeParams.paymentStatusSuccessMessage)
        : undefined,
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      paymentStatusSuccessMessage:
        parseRouteParamToObject<PaymentStatusMessage>(
          routeParamsString.paymentStatusSuccessMessage,
        ) || DEFAULT_PAYMENT_STATUS_SUCCESS_MESSAGE,
      selectedProduct:
        parseRouteParamToEnum(routeParamsString.selectedProduct, ProductID) ||
        DEFAULT_SELECT_PRODUCT,
      selectedProductRatePlan:
        parseRouteParamToInt(routeParamsString.selectedProductRatePlan) ||
        DEFAULT_SELECT_PRODUCT_RATE_PLAN,
    };
  },
});
